import { render, staticRenderFns } from "./comp1.vue?vue&type=template&id=59a47a63"
import script from "./comp1.vue?vue&type=script&lang=js"
export * from "./comp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports